class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M14.5 11h-7v1h7v-1Zm0-7h-7v1h7V4Zm-11 2V2h-1v.5h-1v1h1V6h-1v1h3V6h-1Zm1 8h-3v-2a1 1 0 0 1 1-1h1v-1h-2V9h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-1v1h2v1Z"></path></svg>';
  }
}
const e = "pi-list-numbered";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
